/**
 * @generated SignedSource<<06532f8e78674c070e6a5ddbfd9c4cda>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ShortcutsSection_spaceSidebarLinks$data = {
  readonly quick: ReadonlyArray<{
    readonly id: string;
    readonly position: number;
    readonly styleClass: string | null;
    readonly title: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly " $fragmentType": "ShortcutsSection_spaceSidebarLinks";
};
export type ShortcutsSection_spaceSidebarLinks$key = {
  readonly " $data"?: ShortcutsSection_spaceSidebarLinks$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShortcutsSection_spaceSidebarLinks">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ShortcutsSection_spaceSidebarLinks",
  "selections": [
    {
      "concreteType": "SpaceSidebarLink",
      "kind": "LinkedField",
      "name": "quick",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "url"
        },
        {
          "kind": "ScalarField",
          "name": "position"
        },
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "styleClass"
        }
      ]
    }
  ],
  "type": "SpaceSidebarLinks"
};

(node as any).hash = "4178b9c870bd737bf11e17f52372c026";

export default node;
